<template>
    <div class="fill-height of-y d-flex flex-column">


        <div class="d-flex align-center justify-center fill-height flex-column" v-if="!selectedFarm">
            <v-icon x-large class="mb-4 grey--text">mdi-tractor-variant</v-icon>
            <span class="grey--text text-h6">Please select a farm to continue</span>
        </div>

        <template v-else>
            <div class="flex-grow-0 pa-2 d-flex justify-space-between">
              
                <v-btn
                        :disabled="false"
                        @click="exportReportData"
                        color="primary"
                        small
                        :loading="exportingData"
                >
                    Export
                </v-btn>
                <div class="flex-grow-1">

                </div>
                <div style="width: 30%">
                    <v-text-field
                            v-model="search"
                            prepend-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            class="pa-0 ma-0"
                    ></v-text-field>
                </div>
<!--                <div>-->
<!--                    <v-btn-->
<!--                            icon-->
<!--                            color="primary"-->
<!--                            class="pa-0 mr-2"-->
<!--                            @click="$emit('update:selected-date', subDays(selectedDate, 1))"-->
<!--                    >-->
<!--                        <v-icon>mdi-chevron-left</v-icon>-->
<!--                    </v-btn>-->
<!--                    <v-btn-->
<!--                            icon-->
<!--                            color="primary"-->
<!--                            class="pa-0 mr-2"-->
<!--                            @click="$emit('update:selected-date', addDays(selectedDate, 1))"-->
<!--                    >-->
<!--                        <v-icon>mdi-chevron-right</v-icon>-->
<!--                    </v-btn>-->
<!--                </div>-->
            </div>
            <div v-if="loading" class="flex-grow-1 d-flex align-center justify-center">
                <loader></loader>
            </div>
            <div v-else class="flex-grow-1 of-y">
                <v-data-table
                        :search="search"
                        dense
                        fixed-header
                        height="100%"
                        class="fill-height of-y"
                        hide-default-footer
                        :headers="headers"
                        :items="data"
                        :options="{itemsPerPage: data.length}"
                ></v-data-table>
            </div>
        </template>


    </div>
</template>

<script>

import {addDays, format, subDays} from "date-fns";
import {mapGetters} from "vuex";
import Loader from "../General/Loader/Loader";

export default {
    components: {Loader},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            search: null,
            headers: [
                {text: "Emp Code", value: "empCode"},
                {text: "Name", value: "fullName"},
                {text: "Description", value: "jobDesc"},
                {text: "Team", value: "team"},
                {text: "In", value: "inTime"},
                {text: "Out", value: "outTime"},
                {text: "Sunday Hours", value: "sundayHours"},
                {text: "Overtime Hours", value: "overtimeHours"},
                {text: "Piece Work Hours", value: "standardHours"},
                {text: "Total Hours", value: "hoursForDay"},
                {text: "Variety", value: "variety"},
                {text: "Team Average", value: "teamAvg"},
                {text: "Under Over Target", value: "underOver"},
                {text: "Bins", value: "bins"},
            ],
            data: [],
            addDays: addDays,
            subDays: subDays,
            exportingData: false,
            loading: false,
        }
    },
    mounted() {
        if (this.selectedFarm && this.selectedDate)
            this.getResultsData()
    },
    watch: {
      

      
        selectedFarm(val) {
            if (val) {
                this.getResultsData()
            }
        },
        selectedDate(val) {
            if (val) {
                this.getResultsData()
            }
        }
    },
    methods: {
        async getResultsData() {
            try {
                this.loading = true;
                this.data = await this.$newReq('POST', `reports/results`, {farm: this.selectedFarm, start: this.selectedDate})
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loading = false
            }
        },
        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/results/export`,
                    {
                        start: this.selectedDate,
                        farm: this.selectedFarm,
                        farmDescription: this.farm.description
                    },
                    `${this.farm.description} Results Report ${format(this.selectedDate, 'MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(['farmsRef']),
        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
        },
        // rows() {
        //     return this.data.map(row => {
        //         return {
        //             farmID: row.farm.id,
        //             farm: row.farm.description,
        //             employee: row.emp.fullName,
        //             empCode: row.emp.empCode,
        //             clockIn: row.clockInStr,
        //             lastAction: row.lastActionStr,
        //             binUnits: row.binUnits,
        //             piecework: row.pieceWorkStr,
        //             pWUnits: row.pieceWorkUnits,
        //             hours: row.hours,
        //         }
        //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
        // }
    },
}
</script>

<style scoped>

</style>